import { render, staticRenderFns } from "./startUpCard.vue?vue&type=template&id=ee77c806&scoped=true&"
import script from "./startUpCard.vue?vue&type=script&lang=js&"
export * from "./startUpCard.vue?vue&type=script&lang=js&"
import style0 from "./startUpCard.vue?vue&type=style&index=0&id=ee77c806&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee77c806",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/oeze/Documents/grupa/grupa-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee77c806')) {
      api.createRecord('ee77c806', component.options)
    } else {
      api.reload('ee77c806', component.options)
    }
    module.hot.accept("./startUpCard.vue?vue&type=template&id=ee77c806&scoped=true&", function () {
      api.rerender('ee77c806', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DevDashboard/overview/vetting/startUps/partials/startUpCard.vue"
export default component.exports